import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class DashboardSummaryService {
  public url = 'api/supplierdashboard';

  constructor(public http: HttpClient) {}

  public GetDBJobCount(): Promise<any> {
    return this.http.get(`${this.url}/getDBJobCount`).toPromise();
  }

  public GetDBJobCountDet(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBJobCountDet?supplierId=` + id).toPromise();
  }

  public GetDBArea(): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBArea`).toPromise();
  }

  public GetDBAreaDet(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/GetDBAreaDet?supplierId=` + id).toPromise();
  }

  public GetDBEarnings(): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBEarnings`).toPromise();
  }

  public GetDBEarningsDet(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/GetDBEarningsDet?supplierId=` + id).toPromise();
  }

  public GetDBStats(): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBStats`).toPromise();
  }

  public GetDBStatsDet(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/GetDBStatsDet?supplierId=` + id).toPromise();
  }

  public GetDBStatsCust(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/GetDBStatsCust?supplierId=` + id).toPromise();
  }

  public getDBData(): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBData`).toPromise();
  }

  public getDBDataDet(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBDataDet?supplierId=` + id).toPromise();
  }

  public getDBRating(): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBRating`).toPromise();
  }

  public getDBRatingDet(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBRatingDet?supplierId=` + id).toPromise();
  }

  public getDBPerformanceDet(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBPerformanceDet?supplierId=` + id).toPromise();
  }

  public getDBABBA(): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBABBA`).toPromise();
  }

  public getDBABBADet(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBABBADet?supplierId=` + id).toPromise();
  }

  public getDBABBACust(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBABBACust?supplierId=` + id).toPromise();
  }

  public GetDBDistance(): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBDistance`).toPromise();
  }

  public GetDBDistanceDet(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/GetDBDistanceDet?supplierId=` + id).toPromise();
  }

  public GetDBRefusedJobs(): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/getDBRefusedJobs`).toPromise();
  }

  public GetDBRefusedJobsDet(id): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/GetDBRefusedJobsDet?supplierId=` + id).toPromise();
  }
}
